export { default } from './WithGlobalityLabelCellContent';
